import React from 'react';
import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
import { HashRouter, BrowserRouter } from 'react-router-dom'
import App from './app/App';
import "./i18n";
import * as serviceWorker from './serviceWorker';
import { Component } from 'react';
import { Provider } from 'react-redux';
import { store,persistor } from './app/redux/store';import { PersistGate } from 'redux-persist/integration/react';


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
    // console.error(error, errorInfo);/
  }

  render() {
    if (this.state.hasError) {
      console.log(this.state.error);
      return <div>Oops! Something went wrong. Error: {this.state.error && this.state.error.toString()}</div>;
    }
    return this.props.children;
  }
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
   <ErrorBoundary>
  <HashRouter>
    {/* <BrowserRouter> */}
    <App />
    {/* </BrowserRouter> */}
    
  </HashRouter>
  </ErrorBoundary>
  </PersistGate>
  </Provider>
, document.getElementById('root'));

serviceWorker.unregister();